interface Data<T> {
  items: T[]
  count: number
}

type Model<T> = {
  [key: string]: Data<T>
}

export interface FetchResult<T> {
  fetchMoreResult: Model<T>
}

export function paginate<T>(key: string) {
  return (prev: Model<T>, { fetchMoreResult }: FetchResult<T>) => {
    if (!fetchMoreResult || !prev[key]?.items || !fetchMoreResult[key].items) return prev
    return Object.assign({}, prev, {
      [key]: {
        ...prev[key],
        count: fetchMoreResult[key].count,
        items: [...prev[key]?.items, ...fetchMoreResult[key].items],
      },
    })
  }
}

interface NestedData<NT> {
  items: NT[]
  count: number
}
type SecondNestedModel<NT> = {
  [secondaryKey: string]: NestedData<NT>
}
type NestedModel<NT> = {
  [primaryKey: string]: SecondNestedModel<NT>
}
export interface NestedFetchResult<NT> {
  fetchMoreResult: NestedModel<NT>
}
export function nestedPaginate<NT>(primaryKey: string, secondaryKey: string) {
  return (prev: NestedModel<NT>, { fetchMoreResult }: NestedFetchResult<NT>) => {
    if (
      !fetchMoreResult ||
      !prev[primaryKey][secondaryKey].items ||
      !fetchMoreResult[primaryKey][secondaryKey].items
    )
      return prev
    return Object.assign({}, prev, {
      [primaryKey]: {
        ...prev[primaryKey],
        [secondaryKey]: {
          ...prev[primaryKey][secondaryKey],
          count: fetchMoreResult[primaryKey][secondaryKey].count,
          items: [
            ...prev[primaryKey][secondaryKey].items,
            ...fetchMoreResult[primaryKey][secondaryKey].items,
          ],
        },
      },
    })
  }
}
